<template>
    <div>
        <div style="margin: 0 20px 20px;display:flex;justify-content: space-between;">
            <div style="display: flex;width:50%">
                <Input placeholder="请输入字典主题" v-model="searchForm.dictTopic" />
                <Input style="margin-left:20px" placeholder="请输入异常码" v-model="searchForm.errorCode">
                </Input>
                <Input style="margin-left:20px" placeholder="请输入消息原文" v-model="searchForm.messageKey">
                </Input>
                <Button type="primary" style="margin-left:20px" @click="handleGetDataSearch">查询</Button>
            </div>
            <div style="display: flex;width:50%;justify-content: flex-end;">
                <Select placeholder="选择模板" style="width: 200px;" v-model="templateId">
                    <Option v-for="(item, index) in templateLi.filter(i => i.id != form.id)" :key="index" :value="item.id">{{
                        item.langName }}</Option>
                </Select>
                <Button style="margin-left: 10px;" type="primary" @click="handleCreatTemplate">创建</Button>
                <Button style="margin-left: 20px;" @click="data.unshift({ isEdit: true })" type="primary">添加一行</Button>
            </div>
        </div>
        <Table :columns="columns" :data="data" :max-height="600">
            <template #messageKey="{ row, index }">
                <div>
                    <div v-if="row.messageType == 0">
                        <Select transfer v-model="data[index].messageKey" :placeholder="row.originalMessage || '请选择'"
                            filterable
                            @on-change="data[index].dictTopic = dictLi.find(i => i.id == $event).dictTopic; data[index].isEdit = true">
                            <Option v-for="(item, i) in dictLi" :key="i" :value="String(item.id)"
                                :disabeld="data.map(i => i.messageKey).includes(item.id)">{{
                                    item.dictTopic+'-'+item.dictName }}</Option>
                        </Select>
                    </div>
                    <div v-else-if="row.messageType == 1">
                        <Input v-model="data[index].messageKey" @on-change="data[index].isEdit = true"></Input>
                    </div>
                    <div v-else-if="row.messageType == 2">
                        <Select v-model="data[index].messageKey" :placeholder="row.originalMessage || '请选择'" transfer
                            filterable @on-change="data[index].errorCode = $event; data[index].isEdit = true">
                            <Option v-for="item in errLi" :key="item.code" :value="item.code"
                                :disabled="data.map(i => i.messageKey).includes(item.code)">{{ item.msg }}</Option>
                        </Select>
                    </div>
                    <div v-else-if="row.messageType == 3">
                        <Input v-model="data[index].messageKey" @on-change="data[index].isEdit = true"></Input>
                    </div>
                    <div v-else>请先选择消息类型</div>
                </div>
            </template>
            <template #messageType="{ row, index }">
                <div>
                    <Select v-model="data[index].messageType" v-if="!row.id" transfer>
                        <Option :value="0">字典</Option>
                        <Option :value="1">普通消息</Option>
                        <Option :value="2">异常消息</Option>
                        <Option :value="3">弹窗</Option>
                    </Select>
                    <div v-else>{{ row.messageTypeFmt }}</div>
                </div>
            </template>
            <template #messageValue="{ index }">
                <Input v-model="data[index].messageValue" @on-change="data[index].isEdit = true"></Input>
            </template>
            <template #action="{ row, index }">
                <div>
                    <Poptip confirm title="确定要删除吗？" transfer @on-ok="handleDelTrans(row.id, index)">
                        <a style="color: red;">删除</a>
                    </Poptip>
                </div>
            </template>
        </Table>
    </div>
</template>

<script>
import { addOrEditLangTrans, delLangTransPage, getLangTransPage, getLangError, getLangDict, delLangTransAll, getLangList } from '@/api/lang'
export default {
    props: {
        form: {},

    },
    data() {
        return {
            data: [],
            templateId: '',
            templateLi: [],
            columns: [
                {
                    title: '序号',
                    width: 70,
                    render: (h,params)=>{
                        return <div>
                                {params.row._index+1}
                            </div>
                    }
                },
                {
                    title: "id",
                    width: 70,
                    key: 'id'
                },
                {
                    title: "消息类型",
                    key: 'messageTypeFmt',
                    slot: 'messageType'
                },
                {
                    title: "消息原文",
                    key: 'messageKey',
                    width: 270,
                    slot: 'messageKey'
                },
                {
                    title: "字典主题",
                    key: 'dictTopic',
                },
                {
                    title: "异常码",
                    key: 'errorCode',
                },


                {
                    title: "消息译文",
                    key: 'messageValue',
                    slot: 'messageValue'
                },
                {
                    title: "操作",
                    key: 'action',
                    slot: 'action',
                }
            ],
            originDictLi: [],
            dictLi: [],
            searchForm: {},
            originErrLi: [],
            errLi: []
        }
    },
    methods: {
        handleGetTemplate() {
            getLangList({ current: -1, size: -1 }).then(r => {
                this.templateLi = r.data.records
            })
        },
        handleCreatTemplate() {
            this.$Modal.confirm({
                title: '创建模板',
                content: '创建模板会删除当前已有的文本记录，是否创建?',
                onOk: async () => {
                    try {
                        await delLangTransAll(this.form.id)
                        this.data = []
                        const { data } = await getLangTransPage({ langId: this.templateId })

                        this.data = data.map(i => ({
                            langId: this.templateId,
                            messageKey: i.messageKey,
                            messageValue: '',
                            messageType: i.messageType,
                            dictTopic: i.dictTopic,
                            errorCode: i.errorCode,
                            isEdit: true,
                        }))
                    } catch (e) {
                        this.$Message.error('操作失败')
                    }
                }
            })
        },
        handleGetDataSearch() {
            if (this.data.findIndex(i => i.isEdit) > -1)
                this.$Modal.confirm({
                    title: '提示',
                    content: '查询后会清空当前未保存的译文信息，是否确认?',
                    onOk: () => {
                        this.handleGetData()
                    }
                })
            else this.handleGetData()
        },
        handleGetDict() {
            getLangDict({ current: -1, size: -1, langId: this.form.id, }).then(r => {
                this.dictLi = r.data.records
                this.originDictLi = [...this.dictLi]
            })
        },
        handleGetErro() {
            getLangError({ current: -1, size: -1, langId: this.form.id, }).then(r => {
                this.errLi = r.data.records
                this.originErrLi = [...this.errLi]
            })
        },
        handleGetData() {
            getLangTransPage({ langId: this.form.id, ...this.searchForm }).then(r => {
                this.data = r.data
            })
        },
        handleDelTrans(id, index) {
            if (id) {
                delLangTransPage(id).then(r => {
                    this.$Message.success('删除成功')
                    this.handleGetData()
                })
            } else {
                this.data.splice(index, 1)
            }

        },
        async handleEdit() {
            try {
                let flag = true
                console.log(this.data.filter(el => el.isEdit));

                const data = this.data.filter(el => el.isEdit).map(el => {
                    if (!el.messageKey || !el.messageValue || (el.messageType != 0) && !el.messageType) flag = false

                    return {
                        id: el.id,
                        langId: this.form.id,
                        messageKey: el.messageKey,
                        messageValue: el.messageValue,
                        messageType: el.messageType
                    }
                })
                if (!flag) {
                    this.$Message.error('请检查并输入所有必填项')
                    throw new Error()
                }

                await addOrEditLangTrans(data)
                this.$Message.success('操作成功')
                this.handleGetData()
            } catch {

            }
        }
    },
    mounted() {
        this.handleGetDict()
        this.handleGetErro()
        this.handleGetData()
        this.handleGetTemplate()
    }
}
</script>